// extracted by mini-css-extract-plugin
export default {"container":"Madeiras_container__aMQaB"};